import React from 'react';

function Header(){
    return <header>
        <img src="./assets/fflogo.png" alt="FistFighters Logo"></img>
        </header>;
  }

  export default Header;